<template>
<div
  :class='listgrid'
  class='paired-comparison-list_list'
>
  <template
    v-for='(option) in options'
    :key='option.id'
  >
    <button
      :class='optionClass(option)'
      class='paired-comparison-list_list-item'
      role='checkbox'
      :aria-checked='isOptionSelected(option) ? "true" : "false"'
      @click.prevent='selectOption(option)'
    >
      <img
        v-if='option.option_image'
        :alt='option.title'
        :src='option.option_image'
        class='paired-comparison-list_list-item_image'
      >

      <span class='paired-comparison-list_list-item_text body-three'>
        {{ option.title }}
      </span>
    </button>
  </template>
</div>
</template>

<script>
export default {
  props: [
    'options',
    'selectOption',
    'isOptionSelected'
  ],

  computed: {
    listgrid() {
      const optionsLength = this.options.length

      if (optionsLength <= 10) {
        return 'grid-2 list-' + optionsLength
      }

      if (optionsLength <= 15) {
        return 'grid-3 list-' + optionsLength
      }

      if (optionsLength > 15) {
        return 'grid-4 list-' + optionsLength
      }

      return null
    }
  },

  methods: {
    optionClass(option) {
      const classes = []
      if (!option.option_image) classes.push('paired-comparison-list_list-item--no-image')
      if (this.isOptionSelected(option)) classes.push('paired-comparison-list_list-item--selected')
      return classes.join(' ')
    }
  }

}
</script>
